import { useStatsigClient } from '@statsig/react-bindings';

export const useGate = (gateName: string) => {
  const { client } = useStatsigClient();

  if (window.Cypress) {
    const overrideGate = window.localStorage.getItem(`overrideGate:${gateName}`);
    if (overrideGate !== null) {
      return overrideGate === '1';
    }

    return false;
  }

  return client.checkGate(gateName);
};
